import search from './solidinterfacesearch.svg';
import backBtn from './icon-OrangeBackArrow.svg';
import cross from './cross-icon.svg';
import info from './info-icon.svg';
import mixedWords from './info-mixed-words.png';
import fillTheGap from './info-fillthegap.png';
import wordmatch from './info-wordmatch.png';
import vinyleQCM from './info-vinyleQCM.png';
import arrowsQCM from './info-arrowsQCM.png';

export const themeSelectorIcons = {
    search,
    backBtn,
    cross,
    info,
    mixedWords,
    fillTheGap,
    wordmatch,
    vinyleQCM,
    arrowsQCM
};